module.exports = __webpack_public_path__ + "img/combine_cells.cd105f12.svg";